import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { fetch } from '@ngrx/router-store/data-persistence';
import { map } from 'rxjs/operators';
import { CurriculumTreeQueries } from '.';
import {
  CurriculumTreeServiceInterface,
  CURRICULUM_TREE_SERVICE_TOKEN,
} from '../../curriculum-tree/curriculum-tree.service.interface';
import { DalState } from '../dal.state.interface';
import {
  CurriculumTreesActionTypes,
  CurriculumTreesLoaded,
  CurriculumTreesLoadError,
  LoadCurriculumTrees,
} from './curriculum-tree.actions';

@Injectable()
export class CurriculumTreeEffects {
  loadCurriculumTrees$ = createEffect(() =>
    this.actions.pipe(
      ofType(CurriculumTreesActionTypes.LoadCurriculumTrees),
      concatLatestFrom(() => this.store.select(CurriculumTreeQueries.getLoaded)),
      fetch({
        run: (action: LoadCurriculumTrees, loaded: boolean) => {
          if (!action.payload.force && loaded) return;
          return this.curriculumTreeService
            .getAllForUser(action.payload.userId)
            .pipe(map((curriculumTrees) => new CurriculumTreesLoaded({ curriculumTrees })));
        },
        onError: (action: LoadCurriculumTrees, error) => {
          return new CurriculumTreesLoadError(error);
        },
      })
    )
  );

  constructor(
    private actions: Actions,
    private store: Store<DalState>,
    @Inject(CURRICULUM_TREE_SERVICE_TOKEN)
    private curriculumTreeService: CurriculumTreeServiceInterface
  ) {}
}
